import { CONTACTOR } from "@pages/deliveryList/config";

export type ConfigType = {
  element: "Autocomplete" | "Textfield" | "Datepicker" | "Range";
  label: string;
  multi?: boolean;
  options?: any[];
  dynamicKey?: string;
  key: string;
  api?: string;
  dynamic?: boolean;
  restricted?: boolean;
  query?: string;
  disabled?: boolean;
  mapperKey?: string;
  valueKey?: string;
  extraParams?: string[] | string;
  min?: number;
  max?: number;
  conditional?: {
    field: string;
    value: string;
  };
  none?: boolean;
};

export const FilterElementMapper: Record<string, ConfigType> = {
  loading_ddt: {
    element: "Autocomplete",
    label: "DDT",
    options: [],
    multi: true,
    mapperKey: "loading_ddt",
    valueKey: "label",
    query: "value",
    key: "loading__ddt_number",
    api: "/api/dropdown/loadings?field_name=ddt_number&required_relation=PL",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  truck_supplier: {
    element: "Autocomplete",
    label: "Carrier",
    options: [],
    multi: true,
    key: "truck_supplier",
    api: "/api/dropdown/suppliers?entity=PL_TRUCK_SUPPLIER",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  terminal: {
    element: "Autocomplete",
    label: "Terminal of Discharge",
    options: [],
    multi: true,
    key: "terminal",
    api: "/api/dropdown/terminals?entity=PL_TERMINAL_DISCHARGE",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  warehousing: {
    element: "Autocomplete",
    label: "Warehousing",
    options: [],
    multi: true,
    key: "warehousing",
    api: "/api/dropdown/warehouses?entity=PL_WAREHOUSE",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "delivery_status__in",
      "whs_id",
      "is_locked_for_whs",
    ],
  },
  deposit_reference: {
    element: "Autocomplete",
    label: "Deposit Reference",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "deposit_reference",
    api: "/api/dropdown/packing-lists?field_name=deposit_reference",
    dynamic: true,
    extraParams: ["shipping_case_id"],
    none: true,
  },
  pile: {
    element: "Autocomplete",
    label: "Pile",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "pile",
    api: "/api/dropdown/packing-lists?field_name=pile",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  row: {
    element: "Autocomplete",
    label: "Row",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "row",
    api: "/api/dropdown/packing-lists?field_name=rows",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  tiers: {
    element: "Autocomplete",
    label: "Tiers",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "tiers",
    api: "/api/dropdown/packing-lists?field_name=tiers",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  depot: {
    element: "Autocomplete",
    label: "Depot",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "depot",
    api: "/api/dropdown/packing-lists?field_name=depot",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  note: {
    element: "Autocomplete",
    label: "Note",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "note",
    api: "/api/dropdown/packing-lists?field_name=unloading_comment",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  claims: {
    element: "Autocomplete",
    label: "Claims",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "claims",
    api: "/api/dropdown/packing-lists?field_name=claims",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  marks: {
    element: "Autocomplete",
    label: "Marks",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "marks",
    api: "/api/dropdown/loadings?field_name=mark&required_relation=PL",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  sender: {
    element: "Autocomplete",
    label: "Sender/Depositor",
    options: [],
    multi: true,
    key: "sender",
    api: "/api/dropdown/customers?entity=PL_DEPOSITOR",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "delivery_status__in",
      "whs_id",
      "is_locked_for_whs",
    ],
    none: true,
  },
  consignee: {
    element: "Autocomplete",
    label: "Consignee",
    options: [],
    multi: true,
    key: "consigee",
    api: "/api/dropdown/customers?entity=PL_CONSIGNEE",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "delivery_status__in",
      "whs_id",
      "is_locked_for_whs",
    ],
    none: true,
  },
  delivery_info: {
    element: "Autocomplete",
    label: "Loading Order",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "delivery_info",
    api: "/api/dropdown/delivery-info?field_name=label&required_relation=PL",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  transport_reason: {
    element: "Autocomplete",
    label: "Transport Reason",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "transport_reason",
    api: "/api/dropdown/loadings?field_name=transport_reason&required_relation=PL",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  fcr: {
    element: "Autocomplete",
    label: "FCR",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "fcr",
    api: "/api/dropdown/fcrs?field_name=fcr_number&required_relation=PL",
    dynamic: true,
    extraParams: ["shipping_case_id"],
    none: true,
  },
  hs_code: {
    element: "Autocomplete",
    label: "HS Code",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "hs_code",
    api: "/api/dropdown/packing-lists?field_name=hs_code",
    dynamic: true,
    extraParams: ["shipping_case_id"],
    none: true,
  },
  caad: {
    element: "Autocomplete",
    label: "Cadd additional code",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "caad",
    api: "/api/dropdown/packing-lists?field_name=caad_code",
    dynamic: true,
    extraParams: ["shipping_case_id"],
    none: true,
  },
  customer: {
    element: "Autocomplete",
    label: "Customer",
    options: [],
    multi: true,
    api: "/api/dropdown/customers?entity=PL_CUSTOMER",
    dynamic: true,
    key: "customer",
    extraParams: ["shipping_case_id"],
  },
  importer: {
    element: "Autocomplete",
    label: "Importer",
    options: [],
    multi: true,
    dynamic: true,
    api: "/api/dropdown/customers?entity=PL_IMPORTER",
    key: "importer",
    extraParams: ["shipping_case_id"],
  },
  supplier: {
    element: "Autocomplete",
    label: "Supplier of the goods",
    options: [],
    multi: true,
    key: "supplier",
    api: "/api/dropdown/suppliers?entity=PL_SUPPLIER_GOODS",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  producer: {
    element: "Autocomplete",
    label: "Mill installation",
    options: [],
    multi: true,
    key: "producer",
    api: "/api/dropdown/suppliers?entity=PL_MILL_INSTALL",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  producer_mill: {
    element: "Autocomplete",
    label: "Mill operator",
    options: [],
    multi: true,
    key: "producer_mill",
    api: "/api/dropdown/suppliers?entity=PL_MILL_OPERATOR",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  bill_of_lading: {
    element: "Autocomplete",
    label: "Bill of Lading",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "bill_of_lading",
    api: "/api/dropdown/bill-of-lading?field_name=mbl_number&required_relation=PL",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "delivery_status__in",
      "whs_id",
      "is_locked_for_whs",
    ],
  },
  vessel: {
    element: "Autocomplete",
    label: "Vessel",
    options: [],
    multi: true,
    key: "vessel",
    api: "/api/dropdown/vessels?entity=PL_OCEAN_VESSEL",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  commodities: {
    element: "Autocomplete",
    label: "Commodities",
    options: [],
    multi: true,
    key: "commodities",
    mapperKey: "commodities",
    query: "name_it",
    api: "/api/dropdown/commodities?entity=PL_COMMODITY",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  id_number: {
    element: "Autocomplete",
    label: "ID Number",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "id_number",
    api: "/api/dropdown/packing-lists?field_name=id_number",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  id_number_release: {
    element: "Autocomplete",
    label: "ID Number",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "id_number_release",
    api: "/api/dropdown/packing-lists?field_name=id_number",
    dynamic: true,
    extraParams: ["fcr_id"],
    none: true,
  },
  thickness: {
    element: "Autocomplete",
    label: "Thickness",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "thickness",
    api: "/api/dropdown/packing-lists?field_name=thickness",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  width: {
    element: "Autocomplete",
    label: "Width",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "width",
    api: "/api/dropdown/packing-lists?field_name=width",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  length: {
    element: "Autocomplete",
    label: "Length",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "length",
    api: "/api/dropdown/packing-lists?field_name=length",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  pieces: {
    element: "Autocomplete",
    label: "Pieces",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "pieces",
    api: "/api/dropdown/packing-lists?field_name=pieces",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  net_weight: {
    element: "Autocomplete",
    label: "Net Weight",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "net_weight",
    api: "/api/dropdown/packing-lists?field_name=net_weight",
    dynamic: true,
    extraParams: ["shipping_case_id"],
    none: true,
  },
  gross_weight: {
    element: "Autocomplete",
    label: "Gross Weight",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "gross_weight",
    api: "/api/dropdown/packing-lists?field_name=gross_weight",
    dynamic: true,
    extraParams: [
      "shipping_case_id",
      "whs_id",
      "is_locked_for_whs",
      "delivery_status__in",
    ],
    none: true,
  },
  grade: {
    element: "Autocomplete",
    label: "Grade",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "grade",
    api: "/api/dropdown/packing-lists?field_name=grade",
    dynamic: true,
    extraParams: ["shipping_case_id"],
    none: true,
  },
  heat: {
    element: "Autocomplete",
    label: "Heat",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "heat",
    api: "/api/dropdown/packing-lists?field_name=heat",
    dynamic: true,
    extraParams: ["shipping_case_id"],
    none: true,
  },
  comment_1: {
    element: "Autocomplete",
    label: "Note 1",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "note_1",
    api: "/api/dropdown/packing-lists?field_name=comment_1",
    dynamic: true,
    extraParams: ["shipping_case_id"],
    none: true,
  },
  comment_2: {
    element: "Autocomplete",
    label: "Note 2",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "note_2",
    api: "/api/dropdown/packing-lists?field_name=comment_2",
    dynamic: true,
    extraParams: ["shipping_case_id"],
    none: true,
  },
  ddt_customer_reference: {
    element: "Autocomplete",
    label: "DDT Customer Reference",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "ddt_customer_reference",
    api: "/api/dropdown/packing-lists?field_name=ddt_customer_reference_number",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  customer_reference: {
    element: "Autocomplete",
    label: "Customer Reference",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "customer_reference",
    api: "/api/dropdown/bl-commodities?field_name=customer_reference_number",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  container: {
    element: "Autocomplete",
    label: "Container",
    options: [],
    multi: true,
    mapperKey: "deposit_reference",
    valueKey: "label",
    query: "value",
    key: "container",
    api: "/api/dropdown/bl-containers?field_name=number&required_relation=PL",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
  transport_contactor: {
    key: "transport_contactor",
    element: "Autocomplete",
    label: "Transport Contractor",
    options: CONTACTOR,
    multi: true,
  },
  transport_contactor_customer: {
    element: "Autocomplete",
    key: "transport_contactor",
    label: "Transport Contractor Customer",
    options: [],
    multi: true,
    api: "/api/dropdown/customers?entity=PL_TC_CUSTOMER",
    dynamic: true,
    conditional: {
      field: "transport_contactor",
      value: "CUSTOMER",
    },
    extraParams: ["shipping_case_id"],
  },
  destination: {
    element: "Autocomplete",
    label: "Destination",
    options: [],
    multi: true,
    key: "destination",
    mapperKey: "destination",
    query: "destination",
    api: "/api/dropdown/customer-addresses?entity=PL_DESTINATION",
    dynamic: true,
    extraParams: ["shipping_case_id", "delivery_status__in", "whs_id"],
    none: true,
  },
  production_method: {
    element: "Autocomplete",
    label: "Production Method",
    options: [],
    multi: true,
    key: "production_method",
    api: "/api/dropdown/production-methods?entity=PL_PRODUCTION_METHOD",
    dynamic: true,
    extraParams: ["shipping_case_id"],
  },
};
